// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__f0qAb","col":"styles_col__2FJOr"};